import React from 'react'
import get from 'lodash-es/get'

import AddEntry from './addEntry'
import EntrySummary from './entrySummary'
import { getItemMatrix } from '../../../../../common/utils/itemMatrix'
import { getCurrentSiteDomain } from '../../../../../common/utils/sites'
import { logError } from '../../../../../common/utils/errors'
import {
  reportEditCartEntryAttempt,
  reportCartSupportUpgrade
} from '../../../../../common/analytics/cartAnalytics'
import setGATracker from '../../../../../common/utils/setGATracker'

export default class AddItemToCart extends React.Component {
  constructor(props) {
    super(props)
    // modal step could be add/edit/summary
    this.state = {
      modalStep: 'add',
      cartEntry: null,
      isLoadingItemMatrix: false,
      loadItemMatrixError: null,
      itemMatrix: null,
      selectedMatrixLicense: null,
      selectedMatrixSupport: null,
      hasSupportBeenExtended: false,
      isAddingItem: false
    }
    this.onAddToCart = this.onAddToCart.bind(this)
    this.onEditCartEntry = this.onEditCartEntry.bind(this)
    this.onMatrixLicenseChange = this.onMatrixLicenseChange.bind(this)
    this.onMatrixSupportChange = this.onMatrixSupportChange.bind(this)
    this.goToEditScreen = this.goToEditScreen.bind(this)
    this.updateMatrixSupport = this.updateMatrixSupport.bind(this)
  }

  componentDidMount() {
    this.setState({
      isLoadingItemMatrix: true
    })
    getItemMatrix(this.props.openModalData.item.id)
      .then(itemMatrix => {
        let defaultSelectedMatrixLicense = itemMatrix
          ? Object.keys(itemMatrix)[0]
          : null
        let defaultSupportOption =
          itemMatrix[defaultSelectedMatrixLicense].support
        let defaultSelectedMatrixSupport = itemMatrix
          ? Object.keys(defaultSupportOption)[0]
          : null
        this.setState({
          isLoadingItemMatrix: false,
          itemMatrix,
          selectedMatrixLicense: defaultSelectedMatrixLicense,
          selectedMatrixSupport: defaultSelectedMatrixSupport
        })
      })
      .catch(error => {
        this.setState({
          isLoadingItemMatrix: false,
          loadItemMatrixError: error
        })
      })
  }

  onMatrixLicenseChange(e) {
    this.setState({
      selectedMatrixLicense: e.target.value
    })
  }

  onMatrixSupportChange(e) {
    this.setState({
      selectedMatrixSupport: e.target.value
    })
  }

  updateMatrixSupport(value) {
    const { openModalData: { item }, currentSite } = this.props
    const { itemMatrix, selectedMatrixLicense } = this.state
    const selectedMatrixSupportOptions = get(
      itemMatrix[selectedMatrixLicense],
      'support'
    )
    const price = get(selectedMatrixSupportOptions[value], 'price').replace(
      '$',
      ''
    )
    reportCartSupportUpgrade({
      item,
      currentSite,
      license: selectedMatrixLicense,
      price,
      support: value
    })
    this.setState({
      hasSupportBeenExtended: true,
      selectedMatrixSupport: value
    })
  }

  onAddToCart() {
    const {
      openModalData: { item },
      addItemToCart,
      dismissModalMessage
    } = this.props
    const { selectedMatrixLicense, selectedMatrixSupport } = this.state
    let data = {
      item_id: item.id,
      license_key: selectedMatrixLicense,
      support_key: selectedMatrixSupport
    }

    setGATracker().then(gaClientId => {
      data.ga_client_id = gaClientId
      this.setState({
        isAddingItem: true
      })
      addItemToCart(data)
        .then(action => {
          if (action && action.type === 'addItemToCartSuccess') {
            dismissModalMessage()
            this.setState({
              modalStep: 'summary',
              cartEntry: action.payload,
              isAddingItem: false
            })
          } else {
            this.setState({
              isAddingItem: false
            })
          }
        })
        .catch(logError)
    })
  }

  onEditCartEntry() {
    const {
      openModalData: { item },
      closeModal,
      editCartEntry,
      dismissModalMessage,
      currentSite
    } = this.props
    const {
      cartEntry,
      selectedMatrixLicense,
      selectedMatrixSupport
    } = this.state

    const data = {
      item_id: item.id,
      license_key: selectedMatrixLicense,
      support_key: selectedMatrixSupport
    }
    editCartEntry(cartEntry.id, data)
      .then(action => {
        if (action && action.type === 'editCartEntrySuccess') {
          dismissModalMessage()
          closeModal()
          window.location = `//${getCurrentSiteDomain(currentSite)}/cart`
        }
      })
      .catch(logError)
  }

  goToEditScreen() {
    reportEditCartEntryAttempt({
      page: '/search/edit-cart-entry' + window.location.search
    })
    this.setState({
      modalStep: 'edit'
    })
  }

  render() {
    const {
      openModalData: { item },
      closeModal,
      modalMessages,
      editCartEntry,
      currentSite
    } = this.props
    const {
      cartEntry,
      modalStep,
      itemMatrix,
      selectedMatrixLicense,
      selectedMatrixSupport,
      loadItemMatrixError,
      hasSupportBeenExtended,
      isAddingItem,
      isLoadingItemMatrix
    } = this.state

    const isLoading = isLoadingItemMatrix || isAddingItem

    if (modalStep === 'add' || modalStep === 'edit') {
      return (
        <AddEntry
          item={item}
          itemMatrix={itemMatrix}
          selectedMatrixLicense={selectedMatrixLicense}
          selectedMatrixSupport={selectedMatrixSupport}
          onMatrixLicenseChange={this.onMatrixLicenseChange}
          onMatrixSupportChange={this.onMatrixSupportChange}
          loadItemMatrixError={loadItemMatrixError}
          modalMessages={modalMessages}
          closeModal={closeModal}
          onAddToCart={this.onAddToCart}
          onEditCartEntry={this.onEditCartEntry}
          modalStep={modalStep}
          isLoading={isLoading}
        />
      )
    } else {
      return (
        <EntrySummary
          item={item}
          itemMatrix={itemMatrix}
          selectedMatrixLicense={selectedMatrixLicense}
          selectedMatrixSupport={selectedMatrixSupport}
          onMatrixLicenseChange={this.onMatrixLicenseChange}
          onMatrixSupportChange={this.onMatrixSupportChange}
          loadItemMatrixError={loadItemMatrixError}
          modalMessages={modalMessages}
          closeModal={closeModal}
          editCartEntry={editCartEntry}
          goToEditScreen={this.goToEditScreen}
          cartEntry={cartEntry}
          updateMatrixSupport={this.updateMatrixSupport}
          hasSupportBeenExtended={hasSupportBeenExtended}
          currentSite={currentSite}
        />
      )
    }
  }
}
